import { SubMenu, Accordion, SubAccordion, SubMenuTwo } from "./DocsComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/fontawesome-free-solid";
import { faDiamond } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDocumentationVersion, setSelectedMenu } from "../../../redux/app/apidocs/apidocs-slice";

const sections = [
  { id: "Overview", title: "Overview" },
  { id: "Authentication", title: "Authentication" },
  {
    id: "Geocodes For Pickup",
    title: "Geocodes For Pickup",
    parent: "Geocodes",
  },
  {
    id: "Geocodes For Drop-Off",
    title: "Geocodes For Drop-Off",
    parent: "Geocodes",
  },
  {
    id: "Generate Search Id_OW",
    title: "Generate Search Id (OW)",
    parent: "Oneway",
  },
  {
    id: "Price With Vehicle_OW",
    title: "Price With Vehicle (OW)",
    parent: "Oneway",
  },
  {
    id: "Booking With Vehicle_OW",
    title: "Booking With Vehicle (OW)",
    parent: "Oneway",
  },
  {
    id: "Generate Search Id_HR",
    title: "Generate Search Id (HR)",
    parent: "Hourly",
  },
  {
    id: "Price With Vehicle_HR",
    title: "Price With Vehicle (HR)",
    parent: "Hourly",
  },
  {
    id: "Booking With Vehicle_HR",
    title: "Booking With Vehicle (HR)",
    parent: "Hourly",
  },
  { id: "Cancel Booking", title: "Cancel Booking" },
  { id: "Driver Details", title: "Driver Details" },
];

export function DocsSidebar() {
  const dispatch = useDispatch();
  const { documentationVersion } = useSelector((state) => state.apidocs);
  const sectionRefs = useRef({});

  // useEffect(() => {
  //   const observerOptions = {
  //     root: null,
  //     rootMargin: "0px",
  //     threshold: 0.5,
  //   };

  //   const observerCallback = (entries) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         dispatch(setSelectedMenu({ selectedMenu: entry.target.id }));
  //       }
  //     });
  //   };

  //   const observer = new IntersectionObserver(
  //     observerCallback,
  //     observerOptions
  //   );

  //   sections.forEach((section) => {
  //     const element = document.getElementById(section.id);
  //     if (element) {
  //       sectionRefs.current[section.id] = element;
  //       observer.observe(element);
  //     }
  //   });

  //   return () => {
  //     Object.values(sectionRefs.current).forEach((element) => {
  //       observer.unobserve(element);
  //     });
  //   };
  // }, []);

  return (
    <div className="h-full pt-4 pb-16 shadow-xl shadow-gray-900/5 overflow-y-scroll scrollbar ">
      <div className="mb-2 p-4">
        <div className="text-lg font-medium">API Documentation</div>
      </div>
      {/* <div>
        <Accordion
          id="V1"
          title="Version 1"
          onCLick={() => {
            dispatch(setDocumentationVersion({ documentationVersion: "V1" }));
          }}
          icon={
            <FontAwesomeIcon
              icon={faBook}
              className="w-5 animate__animated animate__bounceIn"
            />
          }
        >
          <SubMenu
            id={"Overview V1"}
            title={"Overview"}
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          />
          <SubMenu
            id={"Authentication V1"}
            title={"Authentication"}
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          />
          <SubAccordion
            id={"Geocodes Main V1"}
            title="Geocodes"
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          >
            <SubMenuTwo
              id={"Geocodes For Pickup V1"}
              title={"Geocodes For Pickup"}
              reqType={"GET"}
            />
            <SubMenuTwo
              id={"Geocodes For Drop-Off V1"}
              title={"Geocodes For Drop-Off"}
              reqType={"GET"}
            />
          </SubAccordion>
          <SubAccordion
            id={"Create Booking Main V1"}
            title="Create Booking"
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          >
            <SubMenuTwo
              id={"Generate Search Id V1"}
              title={"Generate Search Id"}
              reqType={"POST"}
            />
            <SubMenuTwo
              id={"Oneway Vehicle With Price V1"}
              title={"Oneway Price With Vehicle"}
              reqType={"POST"}
            />
            <SubMenuTwo
              id={"Hourly Vehicle With Price V1"}
              title={"Hourly Price With Vehicle"}
              reqType={"POST"}
            />
            <SubMenuTwo
              id={"Booking With Vehicle V1"}
              title={"Booking With Vehicle"}
              reqType={"POST"}
            />
          </SubAccordion>
          <SubMenuTwo
            id={"Booking Details V1"}
            title={"Booking Details"}
            reqType={"GET"}
          />

          <SubMenuTwo
            id={"Cancel Booking V1"}
            title={"Cancel Booking"}
            reqType={"PATCH"}
          />
          <SubMenuTwo
            id={"Driver Details V1"}
            title={"Driver Details (tracking)"}
            reqType={"GET"}
          />
        </Accordion>
      </div> */}
      <div>
        <Accordion
          id="V2"
          title={
            <div>
              Drivado APIs
            </div>
          }
          onCLick={() => {
            dispatch(setDocumentationVersion({ documentationVersion: "V2" }));
          }}
          icon={
            <FontAwesomeIcon
              icon={faBook}
              className="w-5 animate__animated animate__bounceIn"
            />
          }
        >
          <SubMenu
            id={"Overview"}
            title={"Overview"}
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          />
          <SubMenu
            id={"Authentication"}
            title={"Authentication"}
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          />
          <SubAccordion
            id={"Geocodes Main"}
            title="Geocodes"
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          >
            <SubMenuTwo
              id={"Geocodes For Pickup"}
              title={"Geocodes For Pickup"}
              reqType={"GET"}
            />
            <SubMenuTwo
              id={"Geocodes For Drop-Off"}
              title={"Geocodes For Drop-Off"}
              reqType={"GET"}
            />
          </SubAccordion>
          <SubAccordion
            id={"Oneway Main"}
            title="Oneway"
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          >
            <SubMenuTwo
              id={"Generate Search Id_OW"}
              title={"Generate Search Id"}
              reqType={"POST"}
            />
            <SubMenuTwo
              id={"Price With Vehicle_OW"}
              title={"Price With Vehicle"}
              reqType={"GET"}
            />
            <SubMenuTwo
              id={"Booking With Vehicle_OW"}
              title={"Booking With Vehicle"}
              reqType={"POST"}
            />
          </SubAccordion>
          <SubAccordion
            id={"Hourly Main"}
            title="Hourly"
            icon={<FontAwesomeIcon icon={faDiamond} className="w-3 h-3" />}
          >
            <SubMenuTwo
              id={"Generate Search Id_HR"}
              title={"Generate Search Id"}
              reqType={"POST"}
            />
            <SubMenuTwo
              id={"Price With Vehicle_HR"}
              title={"Price With Vehicle"}
              reqType={"GET"}
            />
            <SubMenuTwo
              id={"Booking With Vehicle_HR"}
              title={"Booking With Vehicle"}
              reqType={"POST"}
            />
          </SubAccordion>
          <SubMenuTwo
            id={"Booking Details"}
            title={"Booking Details"}
            reqType={"GET"}
          />

          <SubMenuTwo
            id={"Cancel Booking"}
            title={"Cancel Booking"}
            reqType={"PATCH"}
          />
          <SubMenuTwo
            id={"Driver Details"}
            title={"Driver Details (tracking)"}
            reqType={"GET"}
          />
        </Accordion>
      </div>
    </div>
  );
}
